import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class SimpleHero extends PureComponent {
    static propTypes = {
        pre: PropTypes.string,
        text: PropTypes.string,
        noFeatured: PropTypes.bool
    };

    render() {
        const { pre, text, noFeatured } = this.props;

        return (
            <div
                className={classNames("simple-hero", {
                    "simple-hero--no-featured": noFeatured
                })}
            >
                <div className="simple-hero__musthead">
                    {pre && <div className="simple-hero__pre">{pre}</div>}
                    {text && (
                        <div className="simple-hero__text">
                            <p>{text}</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default SimpleHero;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/SimpleHero.js